function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import pathOr from 'ramda/src/pathOr';
import pluck from 'ramda/src/pluck';
import without from 'ramda/src/without';
import { getReplaceItems } from './subscription.order.helper';
var _default = /*#__PURE__*/function () {
  function _default(state, stripInvalidCoupons) {
    _classCallCheck(this, _default);
    this.state = state;
    this.stripInvalidCoupons = !!stripInvalidCoupons;
  }
  return _createClass(_default, [{
    key: "createOrder",
    value: function createOrder(additionalProperties) {
      var state;
      if (this.state.isCreatingMode) {
        state = createNewOrder(this.state, this.stripInvalidCoupons);
      } else if (this.state.isReplacingMode) {
        state = createReplaceSubscriptionOrder(this.state, this.stripInvalidCoupons);
      } else if (this.state.isModifyingMode) {
        state = createChangeOrder(this.state, this.stripInvalidCoupons);
      } else if (this.state.isRestoringMode) {
        state = createRestoreOrder(this.state, this.stripInvalidCoupons);
      }
      return Object.assign(state, additionalProperties);
    }
  }]);
}();
export { _default as default };
var createBaseOrder = function createBaseOrder(state, stripInvalidCoupons) {
  var couponCodes = pluck('name', state.couponCodes);
  if (stripInvalidCoupons && state.invalidCouponRedemptions) {
    var invalidCoupons = pluck('RedemptionCode', state.invalidCouponRedemptions);
    couponCodes = without(invalidCoupons, couponCodes);
  }
  if (state.searchCouponCode) {
    couponCodes.push(state.searchCouponCode);
  }
  var isPaymentInstrumentRequired = pathOr(true, ['shoppingCart', 'PaymentInstrumentRequired'], state);
  // default is true because we want to only *not* send the PaymentInstrumentIds when they are explicitly *not* required for the cart
  // This needed to be changes due tu PD-380701 Payment Instrument Not Associated to $0 Order/Subscription

  var returnObject = {
    customerId: state.currentCustomer.Id,
    discretionaryDiscountReasonCode: pathOr(null, ['discretionaryDiscountReason', 'value'], state),
    discretionaryDiscounts: state.discretionaryDiscountIds,
    redemptionCodes: couponCodes
  };
  returnObject.recordPaymentInfo = pathOr(true, ['recordPaymentInfo'], state);
  if (!returnObject.recordPaymentInfo) {
    returnObject.useDefaults = false;
    returnObject.paymentInstruments = state.paymentInstrumentsClean;
  } else {
    returnObject.useDefaults = isPaymentInstrumentRequired;
    returnObject.paymentInstrumentIds = state.paymentInstrumentIds;
  }
  return returnObject;
};
var createNewOrder = function createNewOrder(state, stripInvalidCoupons) {
  var order = createBaseOrder(state, stripInvalidCoupons);
  order.shoppingCart = state.shoppingCart;
  order.shippingAddressId = state.orderRequiresShipping ? state.shippingAddressId : null;
  order.shippingMethodId = state.orderRequiresShipping ? state.shippingMethodId : null;
  order.shipToName = state.orderRequiresShipping ? state.shipToName : null;
  order.orderDetails = state.orderDetails || null;
  return order;
};
var createReplaceSubscriptionOrder = function createReplaceSubscriptionOrder(state, stripInvalidCoupons) {
  var order = createBaseOrder(state, stripInvalidCoupons);
  var subscriptionItemToReplaceId = pathOr(null, ['replaceItem', 'id'], state);
  var replacementItem = state.replacementItem ? state.replacementItem : state.shoppingCart.Items[0];
  order.modificationObject = {
    ChangeImmediately: state.changeImmediately,
    ReplaceItems: getReplaceItems(replacementItem, subscriptionItemToReplaceId),
    SubscriptionId: state.currentSubscription.Id
  };
  order.shippingAddressId = state.orderRequiresShipping ? state.shippingAddressId : null;
  order.shippingMethodId = state.orderRequiresShipping ? state.shippingMethodId : null;
  order.shipToName = state.orderRequiresShipping ? state.shipToName : null;
  return order;
};
var createChangeOrder = function createChangeOrder(state, stripInvalidCoupons) {
  var order = createBaseOrder(state, stripInvalidCoupons);
  order.modificationObject = {
    ChangeImmediately: state.changeImmediately,
    SubscriptionId: state.currentSubscription.Id,
    AddItems: state.modifyItemRequestData.AddItems,
    ChangeItems: state.modifyItemRequestData.ChangeItems,
    RemoveItems: state.modifyItemRequestData.RemoveItems
  };
  if (state.orderRequiresShipping) {
    order.shippingAddressId = state.shippingAddressId;
    order.shippingMethodId = state.shippingMethodId;
    order.shipToName = state.shipToName;
  }
  return order;
};
var createRestoreOrder = function createRestoreOrder(state, stripInvalidCoupons) {
  var order = createBaseOrder(state, stripInvalidCoupons);
  order.subscriptionId = state.currentSubscription.Id;
  if (state.currentSubscription.Items[0].Shipped) {
    order.shippingAddressId = state.shippingAddressId;
    order.shippingMethodId = state.shippingMethodId;
    order.shipToName = state.shipToName;
  }
  order.waiveFee = state.waiveFee;
  order.waiveFeeReason = state.waiveFeeReason;
  order.waiveLateFee = state.waiveLateFee;
  order.waiveLateFeeReason = state.waiveLateFeeReason;
  return order;
};